import React, { Component } from 'react';
import assign from 'object-assign';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';

import ProgrammeActions from '../../actions/ProgrammeActionCreator';
import ProgrammeStore from '../../stores/ProgrammeStore';
import { withId } from '../Common/Decorators';

class ProgrammeForm extends Component {

    constructor(props)  {
        super(props);
        this.state = {
            details: {
                id: '',
                name: '',
                description: ''
            }
        };
    }

    componentDidMount() {
        this.onChange = this.onChange.bind(this);
        this.onSave = this.onSave.bind(this);

        ProgrammeStore.addChangeListener(this.onChange);
        if(!!this.props.id) {
            ProgrammeActions.getById(this.props.id);
        }
    }

    componentWillUnmount() {
        ProgrammeStore.removeChangeListener(this.onChange);
    }

    render () {

        return(
            <Form
                title={(!!this.props.id ? this.state.details.name : 'New training programme')}
                onSave={this.onSave}
                redirectTo={(!!this.props.id ? `/dashboard/programme/${this.state.details.id}` : '/dashboard/programmes')}
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:80"
                            validationError="Please use only numbers and letters, at least 2"
                            hintText="Name"
                            floatingLabelText="Name"
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            multiLine={true}
                            rowsMax={8}
                            hintText="Description"
                            floatingLabelText="Description"
                        />
                    </CardText>
                </Card>
            </Form>
      );
    }

    onSave (model) {
        if(!!this.props.id) {
            return ProgrammeActions.update(this.props.id, model);
        } else {
            return ProgrammeActions.save(model);
        }
    }

    onChange() {
        this.setState(assign({}, this.state, {
            details: ProgrammeStore.getById(this.props.id)
        }));
    }

}


export default withId(ProgrammeForm);
